import * as ActionTypes from "./actionTypes";
import * as urls from "../common/urls";
import axios from "axios";


export function getTranslations(locale) {
    const url = `${urls.GET_TRANSLATIONS_URL}?localeIds=${locale}`;
    const request = axios.get(url);
    return { type: ActionTypes.GET_TRANSLATIONS, payload: request };

}
